// extracted by mini-css-extract-plugin
module.exports = {"card":"Services2_card__2G18R","footer":"Services2_footer__1Qxx2"};